import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

const darkOverlay = (opacity: number) =>
	`color-mix(in srgb, ${THEME.colors.chart.topHatBlack} ${opacity}%, transparent)`;
const lightOverlay = (opacity: number) =>
	`color-mix(in srgb, ${THEME.colors.primary.contrastText} ${opacity}%, transparent)`;

export const styles = StyleSheet.create({
	backdrop: {
		backgroundColor: darkOverlay(82),
		backdropFilter: 'blur(10px)',
	},
	popup: {
		inset: 0,
		left: 0,
		top: 0,
		translate: 'none',
		width: '100vw',
		height: '100dvh',
		maxWidth: 'none',
		maxHeight: 'none',
		padding: 0,
		border: 'none',
		borderRadius: 0,
		backgroundColor: 'transparent',
		boxShadow: 'none',
		overflow: 'hidden',
	},
	toolbar: {
		position: 'relative',
		zIndex: 1,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexShrink: 0,
		gap: THEME.spacing.md,
		marginBottom: 0,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		backgroundColor: darkOverlay(68),
	},
	toolbarIdentity: {
		display: 'flex',
		alignItems: 'center',
		minWidth: 0,
		gap: THEME.spacing.sm,
	},
	toolbarButton: {
		width: THEME.spacing.xxl,
		height: THEME.spacing.xxl,
		flexShrink: 0,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.primary.contrastText,
		backgroundColor: 'transparent',
		':hover': {
			color: THEME.colors.primary.contrastText,
			backgroundColor: lightOverlay(16),
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.contrastText}`,
			outlineOffset: 2,
		},
	},
	title: {
		...THEME.common.truncate,
		maxWidth: '60vw',
		color: THEME.colors.primary.contrastText,
		fontSize: THEME.typography.fontSizes.md,
	},
	stage: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexGrow: 1,
		minWidth: 0,
		minHeight: 0,
		padding: THEME.spacing.lg,
		overflow: 'auto',
		cursor: 'zoom-out',
		...THEME.common.scrollBar,
	},
	stageZoomed: {
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	mediaStage: {
		cursor: 'default',
	},
	video: {
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.chart.topHatBlack,
	},
	audioCard: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		width: '100%',
		maxWidth: 520,
		padding: THEME.spacing.lg,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: darkOverlay(78),
		color: THEME.colors.primary.contrastText,
	},
	audioCardName: {
		...THEME.common.truncate,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	audioPlayer: {
		width: '100%',
	},
	playbackError: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.md,
		maxWidth: 420,
		padding: THEME.spacing.lg,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: darkOverlay(78),
		color: THEME.colors.primary.contrastText,
		textAlign: 'center',
	},
	playbackErrorText: {
		margin: 0,
		fontSize: THEME.typography.fontSizes.sm,
	},
	image: {
		display: 'block',
		width: '100%',
		height: 'auto',
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
		transformOrigin: 'center',
		transition: 'transform 150ms ease-out',
		cursor: 'default',
		userSelect: 'none',
	},
	imageZoomed: {
		transformOrigin: 'top left',
	},
	zoomControls: {
		position: 'fixed',
		left: '50%',
		bottom: THEME.spacing.lg,
		zIndex: 2,
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		padding: THEME.spacing.xs,
		translate: '-50% 0',
		borderRadius: THEME.common.borderRadius,
		backgroundColor: darkOverlay(78),
		color: THEME.colors.primary.contrastText,
	},
	zoomButton: {
		width: THEME.spacing.xxl,
		height: THEME.spacing.xxl,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.primary.contrastText,
		':hover': {
			color: THEME.colors.primary.contrastText,
			backgroundColor: lightOverlay(16),
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.contrastText}`,
			outlineOffset: 2,
		},
	},
	zoomLevel: {
		minWidth: THEME.spacing.xxxl,
		textAlign: 'center',
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
});
